import type {SupportContext} from "../model/user/SupportContext.ts";

const KEY = "supportContext";

// Per tab on purpose: a reload keeps the context, another tab starts without one.
export const loadSupportContext = (): SupportContext | null => {
    try {
        const stored = sessionStorage.getItem(KEY);
        return stored ? JSON.parse(stored) as SupportContext : null;
    } catch {
        return null;
    }
};

export const saveSupportContext = (context: SupportContext | null): void => {
    try {
        if (context) {
            sessionStorage.setItem(KEY, JSON.stringify(context));
        } else {
            sessionStorage.removeItem(KEY);
        }
    } catch {
        // storage unavailable: the context then lasts until the next reload
    }
};

const RECENT_KEY = "supportContextRecent";
export const MAX_RECENT_SUPPORT_CONTEXTS = 8;

const recentKey = (accountId: string) => `${RECENT_KEY}:${accountId}`;

// Per user and browser, so support can jump back into the customers they just worked for.
export const loadRecentSupportContexts = (accountId: string): SupportContext[] => {
    try {
        const stored = localStorage.getItem(recentKey(accountId));
        return stored ? JSON.parse(stored) as SupportContext[] : [];
    } catch {
        return [];
    }
};

export const rememberSupportContext = (accountId: string, context: SupportContext): void => {
    const others = loadRecentSupportContexts(accountId)
        .filter(recent => recent.type !== context.type || recent.no !== context.no);
    try {
        localStorage.setItem(recentKey(accountId), JSON.stringify([context, ...others].slice(0, MAX_RECENT_SUPPORT_CONTEXTS)));
    } catch {
        // storage unavailable: the start page then shows no recent contexts
    }
};
